import React, { PureComponent } from "react";
import { Avatar, Card, Col, List, Row } from "antd/lib/index";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import { selectCurrentUser } from "../../../redux/selectors/auth";
import {
  selectGroupByKey,
  selectStudentsByGroupKey
} from "../../../redux/selectors/groups";
import { selectCurrentViaje } from "../../../redux/selectors/viajes";

class DescripcionViaje extends PureComponent {
  render() {
    const { group, students, viaje } = this.props;

    return (
      <React.Fragment>
        <div
          style={{
            background: "#ECECEC",
            padding: "30px"
          }}
        >
          <Row gutter={16}>
            <Col span={12} style={{ padding: "0 50px" }}>
              <Card title="" style={{ minHeight: 300, marginTop: "50px" }}>
                <Card title={group.nombreGrupo} />
                <Card.Grid style={{ width: "100%", textAlign: "center" }}>
                  <List
                    itemLayout="horizontal"
                    locale={{
                      emptyText:
                        "No haz creado o no tienes asignado un grupo aun"
                    }}
                    dataSource={students}
                    loading={!!group.key && students.length === 0}
                    renderItem={item => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<Avatar src="" />}
                          title={item.nombre}
                        />
                      </List.Item>
                    )}
                  />
                </Card.Grid>
              </Card>
            </Col>
            <Col span={12} style={{ padding: "0 50px" }}>
              <Card
                title={`Nivel: ${viaje.nivel}`}
                style={{ minHeight: 300, marginTop: "50px" }}
              >
                {viaje.descripcion &&
                  viaje.descripcion.split("\n").map(item => {
                    return (
                      <span key={uuid()}>
                        {item}
                        <br />
                      </span>
                    );
                  })}
              </Card>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = selectCurrentUser(state);
  const group = selectGroupByKey(state, currentUser.groupKey) || {};
  const students =
    (currentUser.groupKey &&
      selectStudentsByGroupKey(state, currentUser.groupKey)) ||
    [];
  const viaje = selectCurrentViaje(state);

  return {
    group,
    currentUser,
    students,
    viaje
  };
};

export default connect(mapStateToProps)(DescripcionViaje);
